import { observer } from 'mobx-react';
import * as React from 'react';
import { T, TPlainTextKey } from '../../../Translations';

const items: ReadonlyArray<TPlainTextKey> = [
  'Admin access to your identity provider (or an IdP administrator on hand)',
  'A SAML 2.0-capable provider - Entra ID, Okta, ADFS, PingFederate, and others all work',
  'About 20 minutes on the IdP side; you can pause and come back anytime',
];

const BeforeYouBegin: React.FC = () => (
  <div>
    <h3 className="text-base font-semibold text-foreground">
      <T kind="Before you begin" />
    </h3>
    <ul className="mt-3 flex list-none flex-col gap-3 rounded-lg border-2 border-dashed border-border bg-secondary p-6">
      {items.map((item) => (
        <li key={item} className="flex gap-3">
          <span className="flex h-5 w-5 shrink-0 translate-y-0.5 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground">
            &#10003;
          </span>
          <span className="text-sm text-foreground">
            <T kind={item} />
          </span>
        </li>
      ))}
    </ul>
  </div>
);

export default observer(BeforeYouBegin);
